import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './types/initialState';
import { RootState } from 'newTypes';

const selectDomain = (state: RootState) => {
  if (state && state.propertyState) {
    return state.propertyState;
  } else {
    return initialState;
  }
};

export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectButtonLoading = createSelector([selectDomain], (state) => state.buttonLoading);
export const selectList = createSelector([selectDomain], (state) => state.List);
export const selectForm = createSelector([selectDomain], (state) => state.form);
export const selectSearch = createSelector([selectDomain], (state) => state.search);
export const selectPageNo = createSelector([selectDomain], (state) => state.pageNo);
export const selectPageSize = createSelector([selectDomain], (state) => state.pageSize);
export const selectTotalRow = createSelector([selectDomain], (state) => state.totalRow);
export const selectOrderBy = createSelector([selectDomain], (state) => state.orderBy);
export const selectOrderDir = createSelector([selectDomain], (state) => state.orderDir);
export const selectStatusFilter = createSelector([selectDomain], (state) => state.status);
export const selectStartDate = createSelector([selectDomain], (state) => state.startDate);
export const selectEndDate = createSelector([selectDomain], (state) => state.endDate);

export const selectExcelUploadList = createSelector([selectDomain], (state) => state.excelList);
export const selectExcelFileList = createSelector([selectDomain], (state) => state.excelFileList);
export const selectExcelPageNo = createSelector([selectDomain], (state) => state.pageNo);
export const selectExcelPageSize = createSelector([selectDomain], (state) => state.pageSize);
export const selectExcelTotalRow = createSelector([selectDomain], (state) => state.totalRow);
export const selectExcelOrderBy = createSelector([selectDomain], (state) => state.orderBy);
export const selectExcelOrderDir = createSelector([selectDomain], (state) => state.orderDir);
